<!-- Communication-->

<div class="document-block" *ngIf="cammuni">
  <div class="headtext">
    <strong id="document">Communication</strong>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="Close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="thumb-content text-center mb-3 mt-2">
    <div class="row">
      <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 All-img">
        <div class="comunicationIcon " (click)="Calls()">
          <img src="../../../../assets/images/Call Icon.svg" class="icon" *ngIf="callIcon">
          <img src="../../../assets/images/communication call unselected.svg" class="icon" *ngIf="fadecallIcon">
        </div>
        <div class="comunicationIcon ml-5" (click)="Notes()">
          <img src="../../../../assets/images/Note Icon.svg" class="icon" *ngIf="noteIcon">
          <img src="../../../assets/images/communication notes unselected.svg" class="icon" *ngIf="fadenoteIcon">
        </div>
        <div class="comunicationIcon ml-5" (click)="Emails()">
          <img src="../../../../assets/images/Email icon.svg" class="icon" *ngIf="emailIcon">
          <img src="../../../assets/images/communication gmail unselected.svg" class="icon" *ngIf="fadeemailIcon">
        </div>
        <div class="comunicationIcon ml-5" (click)="SMSS()">
          <img src="../../../../assets/images/SMS Icon.svg" class="icon" *ngIf="smsIcon">
          <img src="../../../assets/images/communication sms unselected.svg" class="icon" *ngIf="fadesmsIcon">
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 comunicationDown">
        <img src="../../../assets/images/download icon.svg"> &nbsp;

        <img src="../../../assets/images/black Plus Icon.svg" (click)="PlushIcon()">
        <div *ngIf="plusIcon">
          <div>
            <img src="../../../assets/images/Gamil icon black.svg" width="12" height="12">
          </div>
          <div>
            <img src="../../../assets/images/sms icon black.svg" width="12" height="12" (click)="showSMS()">
          </div>
          <img src="../../../assets/images/call icon black.svg" width="12" height="12" (click)="showSMS()">
        </div>
      </div>
    </div>
  </div>

  <!-- Call Detail -->
  <div class="row mt-5" *ngIf="call">
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <div class="checkbox-icon">
        <input type="checkbox">
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
      <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
      <div class="chat-message">
        <div class="icon-img">
          <img src="../../../assets/images/decument call red icon.svg" width="10" height="10" style="margin: 6px;">
          <p class="date-time">12-10-2024 12:10</p>
        </div>
        <b>shubham sharma: -</b>
        Good Morning Thank you for reaching out to our Client
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <img src="../../../assets/images/send sms Arrow.svg" width="25" height="25">
    </div>
    <div class="row mt-3">
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <div class="checkbox-icon">
          <input type="checkbox">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div class="chat-message">
          <div class="icon-img">
            <img src="../../../assets/images/decument call red icon.svg" width="10" height="10" style="margin: 6px;">
            <p class="date-time">12-10-2024 12:15</p>
          </div>
          <b>Alok sharma: -</b>
          Good Morning Thank you for reaching out to our Client
        </div>
        <div class="sendimgdata">
          <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <img src="../../../assets/images/received sms Arrow.svg" width="25" height="25">
      </div>
    </div>
  </div>

  <!-- Note Details -->
  <div class="row mt-5" *ngIf="note">
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <div class="checkbox-icon">
        <input type="checkbox">
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
      <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
      <div class="chat-message">
        <div class="icon-img">
          <img src="../../../assets/images/Document Note red icon.svg" width="10" height="10" style="margin: 6px;">
          <p class="date-time">12-10-2024 01:05</p>
        </div>
        <b>Rahul Kumar: -</b>
        Good Morning Thank you for reaching out to our Client
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <!-- <img src="../../../assets/images/send sms Arrow.svg" width="25" height="25"> -->
    </div>
    <div class="row mt-3">
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <div class="checkbox-icon">
          <input type="checkbox">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div class="chat-message">
          <div class="icon-img">            
            <img src="../../../assets/images/Document Note red icon.svg" width="10" height="10" style="margin: 6px;">
            <p class="date-time">12-10-2024 01:07</p>
          </div>
          <b>Pankaj Kumar: -</b>
          Good Morning Thank you for reaching out to our Client
        </div>
        <div class="sendimgdata">
          <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <!-- <img src="../../../assets/images/received sms Arrow.svg" width="25" height="25"> -->
      </div>
    </div>
  </div>

  <!-- Email Details -->
  <div class="row mt-5" *ngIf="email">
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <div class="checkbox-icon">
        <input type="checkbox">
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
      <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
      <div class="chat-message">
        <div class="icon-img">         
          <img src="../../../assets/images/Document Mail red icon.svg" width="10" height="10" style="margin: 6px;">
          <p class="date-time">12-10-2024 11:03</p>
        </div>
        <b>Ashish Singh: -</b>
        Good Morning Thank you for reaching out to our Client
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <img src="../../../assets/images/send sms Arrow.svg" width="25" height="25">
    </div>
    <div class="row mt-3">
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <div class="checkbox-icon">
          <input type="checkbox">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div class="chat-message">
          <div class="icon-img">            
            <img src="../../../assets/images/Document Mail red icon.svg" width="10" height="10" style="margin: 6px;">
            <p class="date-time">12-10-2024 11:03</p>
          </div>
          <b>Pooja Kumari: -</b>
          Good Morning Thank you for reaching out to our Client Support
        </div>
        <div class="sendimgdata">
          <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <img src="../../../assets/images/received sms Arrow.svg" width="25" height="25">
      </div>
    </div>
  </div>

  <!-- SMS Details -->
  <div class="row mt-5" *ngIf="sms">
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <div class="checkbox-icon">
        <input type="checkbox">
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
      <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
      <div class="chat-message">
        <div class="icon-img">         
          <img src="../../../assets/images/decument sms red icon.svg" width="10" height="10" style="margin: 6px;">
          <p class="date-time">12-10-2024 03:02</p>
        </div>
        <b>Ankita sharma: -</b>
        Good Morning Thank you for reaching out to our Client
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
      <img src="../../../assets/images/send sms Arrow.svg" width="25" height="25">
    </div>
    <div class="row mt-3">
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
        <div class="checkbox-icon">
          <input type="checkbox">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div class="chat-message">
          <div class="icon-img">            
            <img src="../../../assets/images/decument sms red icon.svg" width="10" height="10" style="margin: 6px;">
            <p class="date-time">12-10-2024 03:03</p>
          </div>
          <b>Pinki Singh: -</b>
          Good Morning Thank you for reaching out to our Client
        </div>
        <div class="sendimgdata">
          <img src="../../../assets/images/profileDefaultPic.svg" width="20" height="20">
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 sms-Arrow">
        <img src="../../../assets/images/received sms Arrow.svg" width="25" height="25">
      </div>
    </div>
  </div>

  <!-- Write Message -->
  <div class="chat-container">
    <!-- Display chat messages here -->
    <div class="chat-messages">
      <div *ngFor="let message of messages"></div>
    </div>

    <!-- Message input box -->
    <!-- <div class="message-input">
      <input type="text" [(ngModel)]="newMessage" placeholder="Type your message..." />
      <button class="btn btn-success" (click)="sendMessage()">Send</button>
    </div>
  </div>
</div> -->

<!--SMS Popup modal -->
<p-dialog [(visible)]="addSMS" [modal]="true" [draggable]="false" [resizable]="false"  [blockScroll]=false [style]="{ width: '30rem' }" *ngIf="addSMS">
  <p-header>
    SMS Pic
    </p-header>
    <p>+91 9876543254</p>
    <p>+91 9876369451</p>
    <p>+91 9885698852</p>
  </p-dialog>
